'use client';

import { Card, CardContent, CardHeader, CardTitle } from '@repo/ui';
import type { JSX } from 'react';
import type { CollectionMasteryItem } from './get-collection-progress';
import { getCollectionProgress } from './get-collection-progress';

export function CollectionMastery({
  collections,
}: {
  collections: CollectionMasteryItem[];
}): JSX.Element {
  if (collections.length === 0) {
    return (
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-lg">Collections</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-sm text-muted-foreground py-4 text-center">
            No collection data yet
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Collections</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {collections.map((c) => {
            const { pct, fraction } = getCollectionProgress(c);
            return (
              <div key={c.collectionId} className="flex items-center gap-3">
                <div className="flex-1 min-w-0">
                  <div className="truncate text-sm font-medium">
                    {c.name || `Collection ${c.collectionId}`}
                  </div>
                  <div className="h-2 bg-muted rounded-full mt-1">
                    <div
                      className="h-full bg-primary rounded-full transition-all"
                      style={{ width: `${pct}%` }}
                    />
                  </div>
                </div>
                <div className="flex flex-col items-end whitespace-nowrap">
                  <span className="text-sm text-muted-foreground">{pct}%</span>
                  {fraction ? (
                    <span className="text-xs text-muted-foreground">{fraction}</span>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
